import { LucideIconData } from 'lucide-angular';

export const PoolCaC44: LucideIconData = [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['circle', { cx: '12', cy: '10', r: '4' }],
  ['path', { d: 'M10 17 H14' }],
];
